import { v4 as uuidv4 } from 'uuid';
import API from 'api/API';
import { SetDraftResponse, SetTrayResponse } from 'api/Responses/SetResponses';
import { setActionSwitch } from 'pages/Set/SetPage.functions';
import { getImage } from 'services/FileService';

export enum StorageType {
  FIREBASE,
  GCS,
  DRAFT,
  FIREBASE_GCS_INCLUDED,
}

export const getSrc = async (
  storageType: StorageType,
  url?: string,
  setCode?: string,
  trayRef?: string,
): Promise<string | undefined> => {
  switch (storageType) {
    case StorageType.DRAFT:
      if (!setCode || !trayRef) return undefined;
      return await API.set.getTrayReferenceImageForDraft(setCode, trayRef);
    case StorageType.GCS:
      if (!url) return undefined;
      return await API.asset.get(url);
    case StorageType.FIREBASE:
      if (!url) return undefined;
      return await getImage(url, true);
    case StorageType.FIREBASE_GCS_INCLUDED:
      if (!url) return undefined;
      return await getImage(url, false);
    default:
      return undefined;
  }
};

export const getGeneratedTempTrayRefImageFromFirebase = (name: string) => {
  return `tray_reference_images/temp/${uuidv4()}_${name}`;
};

export const dataUriToFile = (dataUri: string, name: string): File => {
  const [header, base64] = dataUri.split(',');
  const type = /^data:([^;]+);base64/.exec(header)?.[1] ?? 'image/png';
  if (!base64 || !header.endsWith(';base64')) throw new Error('Invalid image data');
  const bytes = Uint8Array.from(atob(base64), c => c.codePointAt(0) ?? 0);
  return new File([bytes], name, { type });
};

export const uploadAndSaveImage = async (
  set: SetDraftResponse,
  trayId: string,
  imagePath: string,
  newTray?: SetTrayResponse,
): Promise<SetDraftResponse> => {
  // If adding a new tray, add this to updatedSet
  const tray = newTray ?? set.trays[trayId];
  // update the set to store the image path
  const updatedSet = {
    ...set,
    trays: { ...set.trays, [tray.reference]: { ...tray, image_file: imagePath } },
  } as SetDraftResponse;

  // save/submit this new set
  await setActionSwitch('save', updatedSet);

  return updatedSet;
};
